import { mapGetters, mapMutations } from "vuex";
import {
    SHOW_POPUP_AUTH_LDAP_WARNING,
} from '@/store/mutation-types'


export default {
    name: 'thanks',
    computed: {
        ...mapGetters({
            popup: 'system/popupLdapWarning',
            config: 'setting/config',
        })
    },
    methods: {
        ...mapMutations({
            changePopup: `system/${SHOW_POPUP_AUTH_LDAP_WARNING}`,
        }),
        getContentItem(key){
            return this.config.find(e => {
                if(e.key === key){
                    return e;
                }
            });
        },
    },
    destroyed(){

    }
}
